import { render } from "./blog-posts-page.vue?vue&type=template&id=a2a3cbc8&scoped=true"
import script from "./blog-posts-page.vue?vue&type=script&lang=js"
export * from "./blog-posts-page.vue?vue&type=script&lang=js"

import "./blog-posts-page.vue?vue&type=style&index=0&id=a2a3cbc8&scoped=true&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a3cbc8"]])

export default __exports__